import { render, staticRenderFns } from "./KontaktView.vue?vue&type=template&id=7e4a5940"
import script from "./KontaktView.vue?vue&type=script&lang=js"
export * from "./KontaktView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports